import type { ReceiptTemplate } from '../schema';

export const pradaTemplate: ReceiptTemplate = {
  id: 'prada',
  name: 'Prada Receipt',
  brand: 'PRADA',
  description: 'Luxury fashion receipt template inspired by Prada stores',
  settings: {
    width: 280,
    font: 'Courier New',
    fontSize: 11,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
  },
  sections: [
    {
      id: 'prada-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/prada.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [
          'Prada New York Broadway',
          '575 Broadway',
          'New York',
          'NY, 10012',
          'Inv. 10111759505',
          'Tel. (212) 334-8888',
        ],
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'prada-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: false,
        quantityPosition: 'left',
        showHeader: true,
        showHeaderDivider: true,
        headerLabels: {
          quantity: 'Qty',
          item: 'Description:',
          amount: 'Price:',
        },
        items: [
          { id: 'prada-item-1', name: 'FERMAGLI IN PLEX PLEX CHA IN JEWELS AVD', price: '$320.00' },
          { id: 'prada-item-2', name: 'SACCA IN TESSUTO CRYSTAL METAL TU', price: '$2,800.00' },
        ],
        showTopDivider: false,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'prada-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'left',
        labelPosition: 50,
        lines: [
          { id: 'prada-subtotal', label: 'Subtotal', value: '3120.00', isBold: false, isLarge: false },
          { id: 'prada-tax', label: 'Sales Tax', value: '218.40', isBold: false, isLarge: false },
          { id: 'prada-total', label: 'TOTAL', value: '3338.40', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 30,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'prada-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'center',
        dateTime: '9/30/2025, 10:56:03 AM',
        format: 'M/D/YYYY, h:mm:ss A',
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'prada-docnum',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'DOCUMENT # 1880-0006',
        fontSize: 11,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'prada-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'prada-card', label: 'Card number', value: '**** **** **** 4922' },
          { id: 'prada-type', label: 'Card type', value: 'Debit' },
          { id: 'prada-entry', label: 'Card entry', value: 'Chip' },
          { id: 'prada-date', label: 'Date/time', value: '11/20/2019 11:09 AM' },
          { id: 'prada-ref', label: 'Reference #', value: '62845289260246240685C' },
          { id: 'prada-status', label: 'Status', value: 'APPROVED' },
        ],
        cashFields: [
          { id: 'prada-cash', label: 'Cash', value: '$3500.00' },
          { id: 'prada-change', label: 'Change', value: '$161.60' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'prada-message',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Prada is happy to offer product exchanges within 10 days of the purchase date, in accordance with any applicable legal guarantees. This exchange policy does not cover personalized items, made-to-measure or made-to-order products, cosmetics, or fragrances. For lingerie, any provided undergarment protection must remain intact. Please note that no exceptions to these requirements will be accepted.',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'prada-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '18800006',
        showValue: true,
        width: 1.5,
        height: 50,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
  ],
};

